var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpService } from "../../../library/http/http.service";
import { getDataFromSessionStorage, validateBackendUrl, } from "../../../config/configHelper";
import { logError, logTrace, } from "../../../library/logging/loggingService";
import { normalizeAzureSubscriptionGuid } from "../subscriptionGuid";
export { normalizeAzureSubscriptionGuid, OTHER_SUBSCRIPTION_OPTION, } from "../subscriptionGuid";
const deduplicateCandidates = (items) => {
    const deduplicated = new Map();
    items.forEach((item) => {
        if (typeof item !== "string") {
            throw new Error("Subscription candidate response contained a non-string item.");
        }
        const normalized = normalizeAzureSubscriptionGuid(item);
        if (!normalized) {
            throw new Error("Subscription candidate response contained an invalid GUID.");
        }
        deduplicated.set(normalized, normalized);
    });
    return Array.from(deduplicated.values());
};
export const getSubscriptionCandidates = (tpid, request, isEU) => __awaiter(void 0, void 0, void 0, function* () {
    const backendUrl = isEU
        ? getDataFromSessionStorage("euFrontdoorbaseurl")
        : getDataFromSessionStorage("globalFrontdoorbaseurl");
    const validatedBackendUrl = validateBackendUrl(backendUrl || "");
    if (!validatedBackendUrl.valid) {
        logError("Invalid backend URL configuration", {
            component: "ConfidenceCall.SubscriptionCandidates",
            action: "ValidateBackendUrl",
            isEU,
            reason: validatedBackendUrl.reason,
        });
        throw new Error("Subscription candidate service is not configured.");
    }
    if (!tpid.trim()) {
        throw new Error("A customer TPID is required to load subscription candidates.");
    }
    if (request.incidentIds.some((incidentId) => !Number.isSafeInteger(incidentId) || incidentId <= 0)) {
        throw new Error("Subscription candidate incident IDs must be positive integers.");
    }
    const route = `/api/accounts/${encodeURIComponent(tpid.trim())}/subscription-candidates`;
    logTrace("Loading Azure subscription candidates", {
        component: "ConfidenceCall.SubscriptionCandidates",
        action: "Load",
        incidentCount: request.incidentIds.length,
        supportRequestCount: request.supportRequestIds.length,
        isEU,
    });
    try {
        const httpService = new HttpService();
        const response = yield httpService.post(validatedBackendUrl.origin, route, undefined, request);
        const data = response === null || response === void 0 ? void 0 : response.data;
        if (!data ||
            !Array.isArray(data.items) ||
            typeof data.totalCount !== "number" ||
            data.totalCount < 0) {
            throw new Error("Subscription candidate response was malformed.");
        }
        return deduplicateCandidates(data.items);
    }
    catch (error) {
        logError("Failed to load Azure subscription candidates", {
            component: "ConfidenceCall.SubscriptionCandidates",
            action: "Load",
            isEU,
            errorMessage: error instanceof Error ? error.message : "Unknown lookup failure",
        });
        throw error;
    }
});
